import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import { Grid, Stack, Typography, useMediaQuery } from '@mui/material'
import logo from './../../assets/images/logo.png'
import { useTranslation } from 'react-i18next'
import { AuthCardWrapper, AuthWrapper, AuthFooter } from './../../components/Main'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { InteractorStoreAccountView } from '../../interactors/Main'
import md5 from 'md5'

const PageInfo = ({ source = 'not_found', message }) => {
  const { t } = useTranslation()
  const useQuery = () => new URLSearchParams(useLocation().search)
  const query = useQuery()
  const sign = query?.get('sign')
  const { account } = useSelector((state) => state.account)
  const theme = useTheme()
  const { viewAccount } = InteractorStoreAccountView()
  const matchDownSM = useMediaQuery(theme.breakpoints.down('md'))

  useEffect(() => {
    if (source !== 'verify' || !sign) return
    if (!account) return
    if (md5(account.uid) !== sign) return
    viewAccount({
      uid: '',
      account_uid: account.uid,
      source: 'verify',
    })
  }, [account, account.uid, sign, source, viewAccount])

  return (
    <AuthWrapper>
      <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }}>
        <Grid item xs={12}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ minHeight: 'calc(100vh - 68px)' }}
          >
            <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
              <AuthCardWrapper>
                <Grid container spacing={2} alignItems="center" justifyContent="center">
                  <Grid item sx={{ mb: 3 }}>
                    <Link to="#">
                      <img src={logo} alt="" className="img-height-150" />
                    </Link>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid
                      container
                      direction={matchDownSM ? 'column-reverse' : 'row'}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Grid item>
                        <Stack alignItems="center" justifyContent="center" spacing={1}>
                          <Typography
                            color={theme.palette.secondary.main}
                            gutterBottom
                            variant={matchDownSM ? 'h5' : 'h4'}
                          >
                            {t(`message.${message}`)}
                          </Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </AuthCardWrapper>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sx={{ m: 3, mt: 1 }}>
          <AuthFooter />
        </Grid>
      </Grid>
    </AuthWrapper>
  )
}

PageInfo.propTypes = {
  message: PropTypes.string,
  source: PropTypes.string,
}

export default PageInfo
